import axios from 'axios';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup } from 'reactstrap';
import Cookies from 'universal-cookie';
import React, { Component } from 'react';
import { ApiUrl } from '../../services/ApiRest';
import swal from 'sweetalert';
import $ from 'jquery';  // Se añade importación de jQuery

const cookie = new Cookies();
const urlListEstudiantesCarreras = ApiUrl + "datosestudiante" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const UrlListarperiodosmatriculadosest = ApiUrl + "listarperiodosmatriculadosest" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlCargaHorariaEstudiantesCarrerasPeriodos = ApiUrl + 'carga-horaria-estudiantes' + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlListaDocsPracticasEst = ApiUrl + 'documentos-practicas-laborales-estudiante' + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";
const urlCargarDocumentoPractica = ApiUrl + 'cargar-documento-practica-estudiante' + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";; // URL para cargar documento
const urlBuscarHorasPractica = ApiUrl + "horaspracticaslabestud/buscar" + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71";

export default class ListPracticasLaborales extends Component {
    constructor(props) {
        super(props);

        this.state = {
            estudiante_id: cookie.get("idEstudiante"),  // Usando cookie para obtener el id del estudiante
            periodo_academico_id: "",
            carrera_id: "",
            currentItems: [],
            carreras: [],
            periodos: [],
            documentosPracticas: [], // Documentos de prácticas
            message: "",
            horaPracticaLabEstId: null,
            loading: true,

            // Estados para el modal de descripción
            modalDescripcionDocumento: false,
            descripcionDocumento: '',

            // Estados para el modal de observación
            modalObservacionDocumento: false,
            observacionDocumento: '',

            // Estado para estudiante seleccionado
            idEstudianteSelect: null,
        };
    }

    componentDidMount() {
        if (this.state.estudiante_id) {
            axios
                .post(urlListEstudiantesCarreras, {
                    idEstudiante: cookie.get("idEstudiante"),
                })
                .then(response => {
                    ;
                    this.setState({ carreras: response.data.data });
                })
        } else {
            console.error("El estudiante_id no está definido.");
        }

        axios
            .post(UrlListarperiodosmatriculadosest, {
                idEstudiantein: cookie.get("idEstudiante"),
                idCarrerae: this.state.idCarrera,
            })
            .then(response => {
                this.setState({ periodos: response.data.data });
            })
            .catch(error => {
                console.error("Error al obtener los periodos académicos", error);
            });
    }


    cargarCargasHorariasYDocumentos = () => {
        this.setState({ loading: true });

        // Primera petición: Obtener prácticas laborales y servicio comunitario
        axios.get(urlCargaHorariaEstudiantesCarrerasPeriodos, {
            params: {
                carrera_id: this.state.carrera_id,
                periodo_academico_id: this.state.periodo_academico_id,
            }
        })
            .then(response => {
                console.log("Carga horaria obtenida:", response.data);

                // Segunda petición: Obtener horas del periodo específico
                axios.post(urlBuscarHorasPractica, {
                    est_id: this.state.estudiante_id,
                    car_id: this.state.carrera_id,
                    per_id: this.state.periodo_academico_id,
                })
                    .then(horasRes => {
                        console.log("Horas periodo:", horasRes.data);
                        console.log("🔍 DEBUG - Total anterior:", horasRes.data.total_horas_cumplidas_anteriores);
                        console.log("🔍 DEBUG - Total general:", horasRes.data.total_horas_cumplidas_total);
                        console.log("🔍 DEBUG - Fecha periodo:", horasRes.data.debug_periodo_fecha);

                        const horasPeriodo = horasRes.data.data || {};
                        // ✅ Ahora obtenemos las horas de periodos ANTERIORES (no incluye el actual)
                        const totalAcumuladoAnteriores = horasRes.data.total_horas_cumplidas_anteriores || 0;

                        // ✅ Combinar los datos con el cálculo correcto
                        const itemsCompletos = response.data.map(item => {
                            const horasTotalesCarrera = item.horas_practicas_laborales || 0;
                            const horasCumplidasPeriodoActual = horasPeriodo.hor_cump || 0;

                            // Horas faltantes = Total carrera - (horas anteriores + horas cumplidas del periodo actual)
                            const horasFaltantesCarrera = horasTotalesCarrera - (totalAcumuladoAnteriores + horasCumplidasPeriodoActual);

                            return {
                                ...item,
                                horas_periodo: horasPeriodo.hor_asig || 0,
                                horas_cumplidas_periodo: horasCumplidasPeriodoActual,
                                horas_faltantes_periodo: (horasPeriodo.hor_asig || 0) - horasCumplidasPeriodoActual,
                                horas_faltantes_carreras: horasFaltantesCarrera < 0 ? 0 : horasFaltantesCarrera,
                                total_acumulado_anteriores: totalAcumuladoAnteriores,


                                nombre_entidad: horasPeriodo.nombre_entidad || "",
                                nombres_tutores_empresariales: horasPeriodo.nombres_tutores_empresariales || "",
                                apellidos_tutores_empresariales: horasPeriodo.apellidos_tutores_empresariales || "",
                                nombres_administrativo: horasPeriodo.nombres_administrativo || "",
                                apellidos_administrativo: horasPeriodo.apellidos_administrativo || ""
                            };
                        });

                        console.log("Items completos calculados:", itemsCompletos);
                        console.log("Total horas anteriores:", totalAcumuladoAnteriores);
                        console.log("Horas cumplidas periodo actual:", horasPeriodo.hor_cump);

                        this.setState({
                            currentItems: itemsCompletos,
                            loading: false,
                            message: itemsCompletos.length === 0
                                ? "No hay horas registradas para este periodo y carrera"
                                : ""
                        });

                        this.cargarDocumentosPracticas();
                    })
                    .catch(error => {
                        console.log("Error horas periodo:", error);
                        this.setState({ loading: false });
                        swal("Error", "No se pudieron cargar las horas del periodo", "error");
                    });
            })
            .catch(error => {
                console.log("Error carga horaria:", error);
                this.setState({ loading: false });
                swal("Error", "No se pudieron cargar las cargas horarias", "error");
            });
    }


    cargarDocumentosPracticas = () => {
        this.setState({ documentosPracticas: [], horaPracticaLabEstId: null });

        axios.post(urlListaDocsPracticasEst, {
            idEstudiante: this.state.estudiante_id,
            idCarrera: this.state.carrera_id,
            idPeriodo: this.state.periodo_academico_id,
        })
            .then(response => {
                console.log("Respuesta documentos:", response.data);

                if (response.data?.success) {
                    this.setState({
                        documentosPracticas: response.data.data || [],
                        horaPracticaLabEstId: response.data.hora_practica_id || null
                    });

                    console.log("ID de hora práctica capturado:", response.data.hora_practica_id);

                    // Solo mostrar alerta si NO hay documentos
                    if (!response.data.data || response.data.data.length === 0) {
                        swal("Información", "No existen documentos registrados.", "info");
                    }
                } else {
                    // Manejar diferentes casos según los flags
                    let mensajeError = response.data.message || "No se pudieron cargar los documentos.";

                    // Verificar los flags específicos
                    if (response.data.sin_carga_horaria_general) {
                        mensajeError = "⚠️ No existe información disponible.\n\nA partir del período académico FEBRERO – JULIO 2026 podrá consultar las horas asignadas y realizar la carga de los documentos de prácticas correspondientes.";
                        $("#divReporteDocumentPractLab").hide();

                    } else if (response.data.sin_asignacion_estudiante) {
                        mensajeError = "⚠️ No tiene horas asignadas en este período académico.\n\nLos documentos estarán disponibles cuando el SUPERVISOR DE PRÁCTICAS LABORALES le asigne las horas correspondientes en este período.";
                    } else if (response.data.sin_horas_asignadas) {
                        mensajeError = "⚠️ No tiene horas asignadas en este período.\n\nContacte al SUPERVISOR DE PRÁCTICAS LABORALES para que le asigne las horas de prácticas laborales.";
                    }

                    swal({
                        title: "Información",
                        text: mensajeError,
                        icon: "info",
                        button: "Entendido"
                    });

                    this.setState({
                        documentosPracticas: [],
                        horaPracticaLabEstId: null
                    });
                }
            })
            .catch(error => {
                console.error("Error al cargar documentos:", error);

                let mensajeError = "Error al cargar los documentos de prácticas laborales.";

                if (error.response?.data?.message) {
                    mensajeError = error.response.data.message;
                }

                swal("Error", mensajeError, "error");

                this.setState({
                    documentosPracticas: [],
                    horaPracticaLabEstId: null
                });
            });
    }

    handleSelectChange = async (e) => {
        await this.setState({ [e.target.name]: e.target.value });
        $("#divReporteDocumentPractLab").show();
        if (this.state.carrera_id && this.state.periodo_academico_id) {
            this.cargarCargasHorariasYDocumentos();
        }
    }

    handleChangeCarrera = async (e) => {
        await this.setState({ [e.target.name]: e.target.value })
        //listar periodos en los que el estudiante se ha matriculado
        axios
            .post(UrlListarperiodosmatriculadosest, {
                idEstudiantein: cookie.get("idEstudiante"),
                idCarrerae: this.state.carrera_id,
            })
            .then(response => {
                this.setState({ periodos: response.data.data });
            })
            .catch(error => {
                console.error("Error al obtener los periodos académicos", error);
            });
    }

    // Modal de descripción de documento
    mostrarModalDescripDocumento = (descripcion) => {
        this.setState({
            modalDescripcionDocumento: true,
            descripcionDocumento: descripcion || ''
        });
    };

    ocultarModalDescripDocumento = () => {
        this.setState({ modalDescripcionDocumento: false });
    }

    // Modal de observación de documento
    mostrarModalObservDocumento = (observacion) => {
        this.setState({
            modalObservacionDocumento: true,
            observacionDocumento: observacion || 'Sin observaciones'
        });
    };

    ocultarModalObservDocumento = () => {
        this.setState({ modalObservacionDocumento: false });
    }

    // Manejo de cambio en observación
    handleChangeObservacion = (e, idDocumento) => {
        const { value } = e.target;
        const { documentosPracticas } = this.state;

        // Actualizar la observación del documento específico
        const updatedDocs = documentosPracticas.map(doc => {
            if (doc.id_documento === idDocumento) {
                return { ...doc, observacion_documento: value };
            }
            return doc;
        });

        this.setState({ documentosPracticas: updatedDocs });
    }

    // Función para cargar documento
    cargarDocumentoPractica = (e, doc) => {
        e.preventDefault();

        // Verificar estado del documento antes de permitir la carga
        if (doc.estado_documento === 1) {
            swal("Advertencia", "El documento ya fue enviado y está pendiente de revisión. No puede enviar otro hasta que el docente lo revise.", "warning");
            return;
        }

        if (doc.estado_documento === 2) {
            swal("Advertencia", "No puede cargar documentos aprobados por el supervisor de prácticas", "warning");
            return;
        }

        // ✅ Agregar validación para estado 4
        if (doc.estado_documento === 4) {
            swal("Advertencia", "No puede cargar documentos aprobados por el tutor", "warning");
            return;
        }

        const fileInput = document.getElementById(`filedocument${doc.id_documento || doc.id_documento_practica_laboral}`);
        const file = fileInput?.files[0];

        if (!file) {
            swal("Advertencia", "Por favor seleccione un archivo", "warning");
            return;
        }

        // Validar tipo de archivo
        const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        if (!allowedTypes.includes(file.type)) {
            swal("Error", "Solo se permiten archivos PDF, DOC o DOCX", "error");
            return;
        }

        // ✅ Obtener el ID del state
        const horaPracticaId = this.state.horaPracticaLabEstId;

        console.log("Datos a enviar:", {
            horaPracticaId,
            documentoId: doc.id_documento_practica_laboral || doc.id_documento,
            estado: doc.estado_documento
        }); // Debug

        if (!horaPracticaId) {
            swal("Error", "No se encontró el ID de horas prácticas laborales. Por favor recargue la página.", "error");
            return;
        }

        const formData = new FormData();
        formData.append('archivorevisado', file);
        formData.append('idhoraspractlabest', horaPracticaId);
        formData.append('iddocumentoestudiante', doc.id_documento_practica_laboral || doc.id_documento);
        formData.append('idestadodocument', 1); // Estado 1 = Enviado para revisión
        formData.append('observaciondoc', ''); // Opcional

        // Debug: Mostrar lo que se envía
        console.log("FormData enviado:");
        for (let pair of formData.entries()) {
            console.log(pair[0] + ': ' + pair[1]);
        }

        swal({
            title: "Cargando...",
            text: "Subiendo documento, por favor espere",
            icon: "info",
            buttons: false,
            closeOnClickOutside: false,
        });

        axios.post(urlCargarDocumentoPractica, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => {
                swal("Éxito", "Documento cargado correctamente y enviado para revisión", "success");
                this.cargarDocumentosPracticas();
                fileInput.value = '';
            })
            .catch(error => {
                console.error("Error al cargar documento:", error);
                console.error("Respuesta del servidor:", error.response?.data);
                swal("Error", error.response?.data?.message || "No se pudo cargar el documento", "error");
            });
    }

    // Función para obtener el texto del estado
    getEstadoTexto = (estado) => {
        switch (parseInt(estado)) {
            case 0:
                return "Pendiente";
            case 1:
                return "Enviado";
            case 2:
                return "Aprobado por supervisor de prácticas";
            case 3:
                return "Rechazado";
            case 4:
                return "Aprobado por tutor";
            default:
                return "Sin estado"; // Aunque esto no debería ocurrir
        }
    }

    // Función para obtener la clase CSS del badge según el estado
    getEstadoBadgeClass = (estado) => {
        switch (parseInt(estado)) {
            case 0:
                return "badge bg-secondary";
            case 1:
                return "badge bg-info";
            case 2:
                return "badge bg-success";
            case 3:
                return "badge bg-danger";
            case 4:
                return "badge bg-primary"; // Color distintivo para aprobado por tutor
            default:
                return "badge bg-secondary";
        }
    }

    render() {
        const { loading, carreras, periodos, currentItems, message, carrera_id, periodo_academico_id, documentosPracticas } = this.state;

        return (
            <div className="row animate__animated animate__fadeIn">

                {/* ================= ENCABEZADO ================= */}
                <div className="card shadow p-3 mb-4 bg-white rounded border-0">
                    <div className="back-istmas">
                        <i className="fa fa-clock bounce-custom fs-5"></i>
                        <b className="ms-2">Gestión de prácticas laborales</b>
                    </div>

                    <div className="card-body">

                        {/* ================= LOADING INICIAL ================= */}
                        {loading && carreras.length === 0 ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-primary" />
                            </div>
                        ) : (
                            <>

                                {/* ================= SELECTS ================= */}
                                <div className="row mb-3">

                                    <div className="col-12 col-lg-6 text-azul">
                                        <label><b><i className="fa fa-graduation-cap"></i> Carrera</b></label>
                                        <select
                                            className="form-select form-select-sm"
                                            name="carrera_id"
                                            value={this.state.carrera_id || ""}
                                            onChange={this.handleChangeCarrera}
                                            disabled={carreras.length === 0}
                                        >
                                            <option value="">
                                                {carreras.length === 0
                                                    ? "No hay carreras disponibles"
                                                    : "Seleccione la carrera"}
                                            </option>
                                            {carreras.map(c => (
                                                <option key={c.id_carrera} value={c.id_carrera}>
                                                    {c.descripcion_carrera}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-12 col-lg-6 text-azul">
                                        <label><b><i className="fa fa-calendar"></i> Periodo Académico</b></label>
                                        <select
                                            className="form-select form-select-sm"
                                            name="periodo_academico_id"
                                            value={this.state.periodo_academico_id || ""}
                                            onChange={this.handleSelectChange}
                                            disabled={periodos.length === 0}
                                        >
                                            <option value="">Seleccione el periodo académico</option>
                                            {periodos.map(p => (
                                                <option key={p.id_periodo_academico} value={p.id_periodo_academico}>
                                                    {p.descripcion_periodo_academico}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                </div>

                                {/* ================= MENSAJE GUÍA ================= */}
                                {!carrera_id || !periodo_academico_id ? (
                                    <div className="alert alert-info py-2 small">
                                        <i className="fas fa-info-circle"></i>
                                        <b className="ms-1">
                                            Seleccione una carrera y un periodo para visualizar su progreso.
                                        </b>
                                    </div>
                                ) : null}
                                {/* =======================
                                    DETALLE DE HORAS (COMPACTO)
                                ======================= */}
                                {carrera_id && periodo_academico_id && !loading && currentItems.length > 0 && (
                                    <div className="card shadow-sm border-0 mt-3">

                                        {/* Header más bajo */}
                                        <div className="card-header back-istmas py-2 text-center">
                                            <small className="fw-semibold text-white">
                                                <i className="fas fa-chart-bar me-1"></i>
                                                DETALLE DE HORAS –{" "}
                                                {this.state.periodos.find(
                                                    p => p.id_periodo_academico == periodo_academico_id
                                                )?.descripcion_periodo_academico}
                                            </small>
                                        </div>


                                        <br />
                                        {/* ================= ENTIDAD-TUTORES (COMPACTO) ================= */}


                                        <div className="d-flex align-items-center mb-2">
                                            <i className="fas fa-building text-info me-2"></i>
                                            <span className="fw-bold">Entidad Formadora: </span>
                                            <span className="fw-semibold text-muted me-1 ms-2"> {currentItems[0].nombre_entidad.toUpperCase() || 0}</span>
                                        </div>

                                        <div className="d-flex align-items-center mb-2">
                                            <i className="fas fa-user-graduate text-primary me-2"></i>
                                            <span className="fw-bold">Tutor Empresarial: </span>
                                            <span className="fw-semibold text-muted me-1 ms-2"> {currentItems[0].nombres_tutores_empresariales.toUpperCase() || 0} {currentItems[0].apellidos_tutores_empresariales.toUpperCase() || 0} </span>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <i className="fas fa-briefcase text-secondary me-2"></i>
                                            <span className="fw-bold">Tutor Académico: </span>
                                            <span className="fw-semibold text-muted me-1 ms-2"> {currentItems[0].nombres_administrativo || 0} {currentItems[0].apellidos_administrativo || 0}  </span>
                                        </div>
                                        <div className="card-body py-3">
                                            <div className="row justify-content-center text-center g-3">

                                                {/* Horas Carrera */}
                                                <div className="col-12 col-md-3">
                                                    <div className="border rounded-3 p-3 h-100">
                                                        <i className="fa fa-calendar-check fa-2x text-info fs-4 mb-1"></i>
                                                        <div className="small text-muted">Horas Carrera</div>
                                                        <div className="fw-bold fs-5">
                                                            {currentItems[0].horas_practicas_laborales || 0} hrs
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Horas Período */}
                                                <div className="col-12 col-md-3">
                                                    <div className="border rounded-3 p-3 h-100">
                                                        <i className="fas fa-clock text-primary fs-4 mb-1"></i>
                                                        <div className="small text-muted">Horas Período</div>
                                                        <div className="fw-bold fs-5">
                                                            {currentItems[0].horas_periodo || 0} hrs
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Horas Cumplidas */}
                                                <div className="col-12 col-md-3">
                                                    <div className="border rounded-3 p-3 h-100">
                                                        <i className="fas fa-check-circle text-success fs-4 mb-1"></i>
                                                        <div className="small text-muted">Horas Cumplidas</div>
                                                        <div className="fw-bold fs-5">
                                                            {currentItems[0].horas_cumplidas_periodo || 0} hrs
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Horas Faltantes */}
                                                <div className="col-12 col-md-3">
                                                    <div className="border rounded-3 p-3 h-100">
                                                        <i className="fas fa-hourglass-half text-danger fs-4 mb-1"></i>
                                                        <div className="small text-muted">Horas Faltantes</div>
                                                        <div className="fw-bold fs-5">
                                                            {currentItems[0].horas_faltantes_carreras || 0} hrs
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* ================= DOCUMENTOS ================= */}
                                {carrera_id && periodo_academico_id && (
                                    <div id="divReporteDocumentPractLab" className="card mt-4 shadow-sm border-0 p-3">

                                        <h6 className="fw-bold text-center text-azul mb-3">
                                            Documentos de Prácticas Laborales
                                        </h6>

                                        <div className="table-responsive">
                                            <table className="table table-hover table-sm-custom">
                                                <thead className="table-light">
                                                    <tr className="text-azul">
                                                        <th>No</th>
                                                        <th>Nombre</th>
                                                        <th>Descripción</th>
                                                        <th>Formato</th>
                                                        <th>Archivo Subido</th>
                                                        <th>Fecha</th>
                                                        <th>Observación</th>
                                                        <th>Cargar</th>
                                                        <th>Estado</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {documentosPracticas.length > 0 ? (
                                                        documentosPracticas.map((doc, index) => (
                                                            <tr key={index} className="text-start">

                                                                {/* Nº */}
                                                                <td>{index + 1}</td>

                                                                {/* Nombre */}
                                                                <td>{doc.nombre_documento}</td>

                                                                {/* Descripción */}
                                                                <td className="text-center">
                                                                    <button
                                                                        className="btn btn-link p-0"
                                                                        title="Ver descripción"
                                                                        onClick={() => this.mostrarModalDescripDocumento(doc.descripcion_documento)}
                                                                    >
                                                                        <i className="fas fa-align-left text-primary"></i>
                                                                    </button>
                                                                </td>

                                                                {/* Formato */}
                                                                <td className="text-center">
                                                                    {doc.ruta_formato ? (
                                                                        <a href={doc.ruta_formato} target="_blank" rel="noreferrer">
                                                                            <i className="fas fa-file-pdf text-danger fs-5"></i>
                                                                        </a>
                                                                    ) : "—"}
                                                                </td>

                                                                {/* Archivo subido */}
                                                                <td className="text-center">
                                                                    {doc.ruta_cargada ? (
                                                                        <a href={doc.ruta_cargada} target="_blank" rel="noreferrer">
                                                                            <i className="fas fa-file-alt text-success fs-5"></i>
                                                                        </a>
                                                                    ) : "—"}
                                                                </td>

                                                                {/* Fecha */}
                                                                <td>{doc.fecha_envio || "-"}</td>

                                                                {/* Observación */}
                                                                <td className="text-center">
                                                                    <button
                                                                        className="btn btn-link p-0"
                                                                        title="Ver observación"
                                                                        onClick={() => this.mostrarModalObservDocumento(doc.observacion_documento)}
                                                                    >
                                                                        <i className="fas fa-comment-dots text-secondary"></i>
                                                                    </button>
                                                                </td>

                                                                {/* Subir archivo */}
                                                                <td>
                                                                    {(doc.estado_documento === 0 || doc.estado_documento === 3) ? (
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <input
                                                                                type="file"
                                                                                accept=".pdf,.doc,.docx"
                                                                                id={`filedocument${doc.id_documento_practica_laboral}`}
                                                                                className="form-control form-control-sm"
                                                                            />
                                                                            <button
                                                                                className="btn btn-secondary btn-sm"
                                                                                title="Subir documento"
                                                                                onClick={(e) => this.cargarDocumentoPractica(e, doc)}
                                                                            >
                                                                                <i className="fas fa-upload"></i>
                                                                            </button>
                                                                        </div>
                                                                    ) : (
                                                                        <small className="text-muted">
                                                                            {doc.estado_documento === 1 && "Pendiente"}
                                                                            {doc.estado_documento === 2 && "Aprobado"}
                                                                        </small>
                                                                    )}
                                                                </td>

                                                                {/* Estado */}
                                                                <td className="text-center">
                                                                    <span className={this.getEstadoBadgeClass(doc.estado_documento)}>
                                                                        {this.getEstadoTexto(doc.estado_documento)}
                                                                    </span>
                                                                </td>

                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="9" className="text-center text-muted py-3">
                                                                No existen documentos asignados.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                )}

                            </>
                        )}
                    </div>
                </div>

                {/* ================= MODALES ================= */}
                <Modal isOpen={this.state.modalDescripcionDocumento} toggle={this.ocultarModalDescripDocumento}>
                    <ModalHeader toggle={this.ocultarModalDescripDocumento}>
                        <h5 className="text-azul">Descripción del Documento</h5>
                    </ModalHeader>
                    <ModalBody>
                        <p>{this.state.descripcionDocumento}</p>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-primary" onClick={this.ocultarModalDescripDocumento}>
                            Cerrar
                        </button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalObservacionDocumento} toggle={this.ocultarModalObservDocumento}>
                    <ModalHeader toggle={this.ocultarModalObservDocumento}>
                        <h5 className="text-azul">Observación</h5>
                    </ModalHeader>
                    <ModalBody>
                        <p>{this.state.observacionDocumento}</p>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-primary" onClick={this.ocultarModalObservDocumento}>
                            Cerrar
                        </button>
                    </ModalFooter>
                </Modal>

            </div>
        );
    }
}

